module.exports = require("memory-fs");


//////////////////
// WEBPACK FOOTER
// external "memory-fs"
// module id = 43
// module chunks = 0